<template>
  <b-modal ref="modal" title="Export Historical Data" lazy>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>

      <v-form-group :validator="$v.client" label="Client" static-label>
        <v-select slot-scope="{ attrs, listeners }"
                  v-model="client"
                  v-bind="attrs"
                  v-on="listeners"
                  :options="clients"
                  multiple
                  placeholder="Client Id"
                  :clearable="false"
                  id="clientId" />
      </v-form-group>
      <v-form-group label="Date Range" static-label>
        <dt-filter-daterange id="dateRange"
                             placeholder="Report Date Placed"
                             @selected="onDateSelect" />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">Generate CSV</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import moment from "moment";
  import { required } from 'vuelidate/lib/validators';

  import modalFormMixin from 'mixins/modal-form-mixin';
  import adminService from "services/admin-service";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('client');

  export default {
    mixins: [modalFormMixin],

    data() {
      return {
        client: [],
        daterange: null
      };
    },

    validations: {
      client: {
        required
      }
    },

    computed: {
      ...mapState(["clients"])
    },

    methods: {
      ...mapActions(["getClientsForFilter"]),

      async beforeShow() {
        await this.getClientsForFilter();
      },

      onDateSelect(val) {
        this.daterange = val;
      },

      async onSubmit() {
        const clientName = this.client.length === 1 ? this.client[0].value : 'multiple';
        const currentDate = moment().format('YYYYMMDD_HHmm');

        await adminService.downloadHistoricalReport({
          clientIds: this.client.map(m => m.value),
          startDate: this.daterange?.start,
          endDate: this.daterange?.end
        }, clientName, currentDate);
      }
    }
  }
</script>
